module.exports = __webpack_public_path__ + "img/icon1.9a96670e.svg";